import { some } from 'lodash';
/**
 * @ngdoc directive
 * @name adjust.apps.directive:withSpaces
 * @scope
 * @restrict E
 *
 * @description
 * Form for tracker creation
 *
 * @param {string} name name to check spaces agains
 *
 */
function withSpaces() {
  'ngInject';
  return {
    restrict: 'E',
    template: require('./with-spaces.html'),
    scope: {},
    controllerAs: 'vm',
    controller: 'WithSpacesController',
    bindToController: {
      name: '=',
    },
  };
}

/**
 * @ngdoc method
 * @name create
 * @methodOf adjust.controller:CreateTrackerController
 *
 * @description
 * All the functionality of the {@link adjust.apps.directive:withSpaces withSpaces} directive
 *
 */
function WithSpacesController($scope, Helper) {
  'ngInject';
  var vm = this;

  vm.spaces = { front: 0, back: 0 };

  $scope.$watch('vm.name', _handleChange);

  Helper.ready(_init);

  /**
   * @ngdoc method
   * @name _init
   * @methodOf adjust.controller:CreateTrackerController
   *
   * @description
   * Initiate space counting from front and back of the string
   *
   * @private
   */
  function _init() {
    if (/^\s/.test(vm.name)) {
      vm.spaces.front = _countSpaces(vm.name);
    }

    if (/\s$/.test(vm.name)) {
      vm.spaces.back = _countSpaces(vm.name.split('').reverse().join(''));
    }
  }

  /**
   * @ngdoc method
   * @name _countSpaces
   * @methodOf adjust.controller:CreateTrackerController
   *
   * @description
   * Count how many spaces are at the beginning of the string
   *
   * @param {string} string string where to check spaces
   * @returns {number} number of spaces
   * @private
   */
  function _countSpaces(string) {
    var count = 0;

    some(string, function (char) {
      if (!/\s/.test(char)) {
        return true;
      }
      count += 1;
    });

    return count;
  }

  /**
   * @ngdoc method
   * @name _handleChange
   * @methodOf adjust.controller:CreateTrackerController
   *
   * @description
   * Reinitiate space counting when string is changed
   *
   * @param {string} n new value
   * @param {string} o old value
   * @private
   */
  function _handleChange(n, o) {
    if (n !== o) {
      _init();
    }
  }
}

export { WithSpacesController, withSpaces };
